import {getSignedUrl, downloadFileAndShowInTab, downloadFileBlob, downloadZip, extractUserIdFromS3Url, prepareAndDownloadZipOfS3Files} from "./FilesAndS3Utils";
import ArrowDownTrayIcon from "@heroicons/react/24/solid/ArrowDownTrayIcon"
import ActionButtonComponent from "@ui-components/ActionButtonComponent";

export const buildWorksiteImagesAndNotesAttachments = (worksite, notesAttachments, worksiteUsers, intl, apiRequest) => {

	/*
	buildAttachmentInfo is a function that builds the info of an attachment
	parameters: the attachment
	return: a string with the info of the attachment
	In this case no promise is needed because the info is already available inside the database
	 */
	const buildAttachmentInfo = async (attachment) => {
		const isoStrM = attachment.loadedOn;
		const dateM = new Date(isoStrM);
		const timestampWithOffsetM = dateM.getTime();
		const timestampWithoutOffsetM = timestampWithOffsetM;
		const dateWithoutOffsetM = new Date(timestampWithoutOffsetM);
		const authorInfo = worksiteUsers
			?.find((u) => u.id === attachment.cod_author)
			?.name
		return `
		${intl.formatMessage({id: "loaded_on"})} 
		${intl.formatDate(new Date(dateWithoutOffsetM), {
			day: "numeric",
			month: "long",
			year: "numeric"
		})}
		${intl.formatMessage({id: "at"})} ${intl.formatTime(new Date(dateWithoutOffsetM))}
		${intl.formatMessage({id: "by"})} ${authorInfo || "-"}
			`
	}

	/*
	buildImageInfo is a function that builds the info of an image
	parameters: the image
	returns a promise with a string with the info of the image.
	A call to S3 is made to get the object attributes of the image
	a promise is returned to make so that the document is visible while the info is being fetched
	and a spinner is shown in the meantime instead of the info
	 */
	const buildImageInfo = async (image) => {
		const objectAttributes = await apiRequest.post('/get_object_attributes', {
			bucket: 'worksite_images',
			prefix: image.image_url.split(".com/").pop()
		})
		const loadedOn = objectAttributes.LastModified
		const isoStrM = loadedOn;
		const dateM = new Date(isoStrM);
		const timestampWithOffsetM = dateM.getTime();
		const timestampWithoutOffsetM = timestampWithOffsetM;
		const dateWithoutOffsetM = new Date(timestampWithoutOffsetM);

		const userId = extractUserIdFromS3Url(image.image_url);
		const authorInfo = worksiteUsers
			?.find((u) => u.id === extractUserIdFromS3Url(image.image_url))
			?.name
		return `
		${intl.formatMessage({id: "loaded_on"})}
		${intl.formatDate(new Date(dateWithoutOffsetM), {
			day: "numeric",
			month: "long",
			year: "numeric"
		})}
		${intl.formatMessage({id: "at"})} ${intl.formatTime(new Date(dateWithoutOffsetM))}
		${intl.formatMessage({id: "by"})} ${authorInfo || "-"}
			`
	}

	const prepareAndDownloadZip = async (documents) => {
		await prepareAndDownloadZipOfS3Files(documents, intl.formatMessage({id: 'attachments_and_images'}), apiRequest)
	}

	return {
		title: intl.formatMessage({id:"other"}),
		alternateColor: "bg-gray-100",
		groups:[
			{
				key: "worksite_images",
				title: intl.formatMessage({id:"worksite_images"}),
				/*
				each document has:
				- a name -> the image name
				- info -> loaded on ... at ... by ... (promise to be resolved see the method buildImageInfo)
				- what to do when the document is clicked
				- s3_url -> the s3 url of the image
				- bucket -> used by the backend to know the proper bucket
				- selected -> whether the document is selected (checkbox clicked)
				- visible -> whether the document is visible (matches the search filter)
				 */
				documents: worksite.images_urls.data.map((image, index) => {
					const extension = image.image_url.split(".").pop();
					const filename = (image.des_image || intl.formatMessage({id: "image_with_no_name"})) + "." + extension;
					return {
						name:filename,
						info: buildImageInfo(image),
						onDocumentClicked: async () => {
							const signed_url = await getSignedUrl(apiRequest, image.image_url, filename, 'worksite_images');
							await downloadFileAndShowInTab(signed_url, filename);
						},
						s3_url: image.image_url,
						bucket: 'worksite_images',
						selected: false,
						visible: true
					}
				})
			},
			{
				key: "worksite_notes_attachments",
				title: intl.formatMessage({id:"notes_attachments"}),
				/*
				each document has:
				- a name -> the attachment name
				- info -> loaded on ... at ... by ...
				- what to do when the document is clicked
				- s3_url -> the s3 url of the attachment
				- selected -> whether the document is selected (checkbox clicked)
				- visible -> whether the document is visible (matches the search filter)
				 */
				documents: notesAttachments?.map(attachment => ({
					name: attachment.filename,
					info: buildAttachmentInfo(attachment),
					onDocumentClicked: async () => {
						const signed_url = await getSignedUrl(apiRequest,
							attachment.attachment_url,
							attachment.filename,
							'worksites_notes_attachments');
						await downloadFileAndShowInTab(signed_url, attachment.filename);
					},
					s3_url: attachment.attachment_url,
					bucket: 'worksites_notes_attachments',
					selected: false,
					visible: true
				}))
			}
		],
		actions: {
			download: {
				actionComponent: (documents, visible) => <ActionButtonComponent
					icon={ArrowDownTrayIcon}
					action={async () => {await prepareAndDownloadZip(documents)}}
				/>
			}
		}
		// /*
		// actions user can do on all the documents of the section
		//  */
		// onAllActions: [
		// 	// download
		// 	{
		// 		actionComponent: (documents, disabled) => <ActionButtonComponent
		// 			icon={ArrowDownTrayIcon}
		// 			action={async () => {await prepareAndDownloadZip(documents)}}
		// 			disabled={disabled}
		// 		/>
		// 	}
		// ],
		// /*
		// actions user can do on the selected documents of the section
		//  */
		// onSelectedActions: [
		// 	// download
		// 	{
		// 		actionComponent: (documents) => <ActionButtonComponent
		// 			icon={ArrowDownTrayIcon}
		// 			text={intl.formatMessage({id: "download"})}
		// 			action={async () => {await prepareAndDownloadZip(documents)}}
		// 			styleType={"white"}
		// 		/>
		// 	}
		// ]
	}
}